import { AxiosRequestConfig } from 'axios'

const getLevels = (): AxiosRequestConfig => ({
  url: `/levels/list`,
  method: 'GET'
})

export { getLevels }
